<template>
  <div>
    <a class="button-link" data-toggle="modal" data-target="#terminateResidencyModal" v-if="residencyId !== null">
      <i class="material-icons">exit_to_app</i>
      Move out of current room
    </a>

    <div class="modal fade" id="terminateResidencyModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content module">
          <div class="modal-header">
            <h1>Are you sure?</h1>
          </div>
          <hr>
          <div class="modal-body">
            <p><strong>Moving out of your room will:</strong></p>
            <ul>
              <li>Delete your personal wireless network</li>
            </ul>
          </div>
          <div class="modal-footer">
            <button class="modal-button" type="button" data-dismiss="modal">Cancel</button>
            <button class="modal-button red" type="button" @click="terminateResidency">End residency</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'

  export default {
    name: 'TerminateResidency',
    props: ['residencyId'],
    methods: {
      terminateResidency(){
        axios({
          method: 'delete',
          url: `/api/v1/residency/${this.residencyId}`,
        }).then((response) => {
          if(response.status === 200){
            location.reload();
          }
        })
      }
    }
  }
</script>